const fieldType = {
    TEXT_INPUT : 0,

    TEXT_AREA : 1,

    YES_NO : 2,

    DROP_DOWN : 3,

    RADIO_GROUP : 4,

    CHECK_BOX : 5,

    CHECK_BOX_GROUP : 6,

    CALENDAR : 7,

    BUTTON : 8,

    LABEL : 9,

    ROWREPEATER : 10,

    SECTIONREPEATER : 11,

    CLASSCODEFINDER : 12,

    RADIO_BUTTON_GROUP : 13,

    SPACER : 14,

    SAME_FIELDS_COPIER : 15,

    HEAT_MAP : 16,

    FUNCTION_BUTTON : 17,

    LIST : 18,

    AMBEST_CARRIERPICKER : 19,

    LINK_BUTTON : 20,

    UPLOAD_ATTACHMENT_BUTTON : 21,

    HTML_GRID : 22,

    POPUP_LIST : 23,

    FORM_SUMMARY_GRID : 24,

    MULTI_SELECT : 25

};

angular.module('gw-um-j2js')
    .constant('fieldType', fieldType);